export const getFilename = ( header: string | null ) =>  {
    const match = header ? header.match( /filename\*=UTF-8''(.*?)$/ ) : undefined;

    const filename = Array.isArray( match ) ? decodeURIComponent( match[1] ) : undefined;
    return filename;
}
